import { supabase } from '../supabase';

// The "coming soon" gate. While it is switched on (Back office > Settings), visitors see a coming soon page and staff can
// unlock the site with a preview password. The password is checked by the "preview-gate" server function, which returns
// a signed pass; the pass is kept in this browser and checked again on every page load.
const KEY = 'sc_preview_pass';
const FALLBACK = 'We could not check that right now. Please try again in a little while.';

const readToken = () => {
  try {
    return window.localStorage.getItem(KEY) || '';
  } catch (e) {
    return '';
  }
};
const saveToken = (token) => {
  try {
    window.localStorage.setItem(KEY, token);
  } catch (e) {
    /* private window: the pass lasts until the page is closed */
  }
};
const clearToken = () => {
  try {
    window.localStorage.removeItem(KEY);
  } catch (e) {
    /* nothing to clear */
  }
};

const readError = async (error) => {
  try {
    const body = await error.context.json();
    return body && body.error ? body.error : null;
  } catch (e) {
    return null;
  }
};

// Returns 'open' (show the site), 'locked' (show the coming soon page) or 'error' (the check could not be made).
export const checkGate = async () => {
  try {
    const { data: enabled, error } = await supabase.rpc('preview_gate_enabled');
    if (error) return 'error';
    if (!enabled) return 'open';

    const token = readToken();
    if (!token) return 'locked';
    const { data, error: passError } = await supabase.functions.invoke('preview-gate', { body: { action: 'check', token } });
    if (passError) return 'error';
    if (data && data.ok === true) return 'open';
    clearToken();
    return 'locked';
  } catch (e) {
    return 'error';
  }
};

// Throws an Error with a message that is safe to show when the password is wrong or too many tries were made.
export const unlockGate = async (password) => {
  const { data, error } = await supabase.functions.invoke('preview-gate', { body: { action: 'unlock', password } });
  if (error) throw new Error((await readError(error)) || FALLBACK);
  if (!data || data.ok !== true || !data.token) throw new Error((data && data.error) || FALLBACK);
  saveToken(data.token);
};
